// セクション３：総合聴解問題 Q21–Q40
// Source: BJT_listen40.txt

export const listenSection3 = [
  {
    id: 21,
    number: '21番',
    type: 'comprehensive_listening',
    difficulty: 'J1+',
    section: 'listening_section3',
    knowledgePoint: '方針転換の聞き取り：守りの経営から攻めの経営へのシフト',
    scene: '部長と課長が来年度の経営方針について話し合っている',
    lines: [
      '部長：今年度はコスト削減を最優先にしてきたわけですが、来年度は方向性を変えようと思っています。',
      '課長：といいますと？',
      '部長：これまでは守りの経営でしたが、来年度は新規事業への投資を積極的に行い、売上を伸ばす方針にしたいんです。',
      '特にアジア市場への展開を加速させたい。',
      '課長：海外展開ですか。人材の確保が課題になりますね。',
      '部長：そうです。現地採用も視野に入れながら、まずは既存人材の育成を強化します。研修予算を倍増させることも検討しています。',
    ],
    options: ['コスト削減の継続と守りの経営', '新規事業への積極投資と人材育成強化', '海外現地採用の全面実施', '研修予算の削減と効率化'],
    answer: 1,
    explanation:
      '部長は「新規事業への投資を積極的に行い」と「既存人材の育成を強化」の2点を核心方針として明言しており，選択肢2が正確に概括している。選択肢1は今年度の方針。選択肢3は「視野に入れながら」つまり検討中であり全面実施とは言っていない。選択肢4は研修予算を倍増させるとあり削減とは正反対。',
  },
  {
    id: 22,
    number: '22番',
    type: 'comprehensive_listening',
    difficulty: 'J2',
    section: 'listening_section3',
    knowledgePoint: '数値の聞き取り：割合・変化方向・計画対比の同時把握',
    scene: '経理部長が今期の業績を取締役会で報告している',
    lines: [
      '経理部長：今期の業績についてご報告いたします。',
      '売上高は前期比5%増加し、計画を達成することができました。',
      'しかしながら、営業利益率は原材料コストの上昇により2ポイント低下し、3%となっております。',
      '来期は調達先の多様化と高付加価値製品の比率向上により、利益率の改善を図ります。',
    ],
    options: ['売上高は計画未達、利益率は5%になった', '売上高は5%増で計画達成、利益率は3%に低下した', '売上高は2%減、利益率は3ポイント向上した', '売上高・利益率ともに計画を大幅に超えた'],
    answer: 1,
    explanation:
      '原文：売上高「前期比5%増、計画達成」、営業利益率「2ポイント低下し3%」。選択肢2が両数値と変化方向を正確に反映。選択肢1は方向が完全に逆。選択肢3は数字が混淆しており方向も誤り。選択肢4は「利益率低下」という事実と矛盾する。数値問題は数字・変化方向・計画との対比の3軸を同時に確認することが重要。',
  },
  {
    id: 23,
    number: '23番',
    type: 'comprehensive_listening',
    difficulty: 'J1',
    section: 'listening_section3',
    knowledgePoint: '優先順位の聞き取り：「まず〜、次に〜」の順番の特定',
    scene: '品質管理の会議で部長が対策の実施順序を指示している',
    lines: [
      '部長：今月の不良品率が上がっています。対策を指示します。',
      'まず材料の入荷検査を強化してください。',
      '次に、製造ラインのスピードを現状より10%落として品質を優先させます。',
      'この2点を今週中に実施してください。ラインの人員配置の見直しは来月以降で構いません。',
    ],
    options: ['ライン速度低下→材料検査強化の順番', '材料検査強化→ライン速度低下の順番', '人員配置見直し→材料検査強化の順番', 'すべて同時並行で実施する'],
    answer: 1,
    explanation:
      '部長は「まず材料の入荷検査を強化」「次にラインのスピードを落とす」と明確な順序で指示している。「まず」「次に」は順序を示す標識語で聴解での優先順位把握に不可欠。人員配置の見直しは来月以降であり今週の課題ではない。選択肢1は順序が逆転しており誤り。',
  },
  {
    id: 24,
    number: '24番',
    type: 'comprehensive_listening',
    difficulty: 'J1+',
    section: 'listening_section3',
    knowledgePoint: '否定型問題：述べられていないものを選ぶ',
    scene: '環境担当者が全社員向けにCO2削減の3つの取り組みを説明している',
    lines: [
      '担当者：来月から3つの取り組みを実施します。',
      '1つ目は社内照明のLED化、これにより電力を約60%削減できます。',
      '2つ目はペーパーレス化の推進で、紙の使用量を半減させます。',
      '3つ目は社用車の電気自動車への切り替えです。今年度に30%、3年以内に100%を目標にします。',
    ],
    options: ['照明のLED化による電力削減', '紙の使用量の半減', '従業員の在宅勤務の推進', '社用車の電気自動車化'],
    answer: 2,
    explanation:
      '原文が述べた3つの措置：LED照明・ペーパーレス化・電気自動車切り替え。「従業員の在宅勤務の推進」は一切言及されておらず選択肢3が正解。否定型問題は全選択肢を原文と照合し、原文に登場しないものを正解として選ぶ。各選択肢を「原文で言った・言わなかった」の2択で判断することが効率的。',
  },
  {
    id: 25,
    number: '25番',
    type: 'comprehensive_listening',
    difficulty: 'J2',
    section: 'listening_section3',
    knowledgePoint: '役割分担の聴解：複数人物の担当を正確に対応させる',
    scene: 'プロジェクトのキックオフミーティングでリーダーが担当を告げている',
    lines: [
      'リーダー：担当を確認します。市場調査は林さん、予算管理は吉田さん、スケジュール管理は私が担います。',
      '林：市場調査の第一次レポートはいつまでですか。',
      'リーダー：3週間後です。最終レポートはプロジェクト終了の2週間前にお願いします。',
      '吉田：予算書は既存フォーマットを使ってよいですか。',
      'リーダー：はい、総務部フォルダの最新版を使ってください。',
    ],
    options: ['林さんが予算管理、吉田さんが市場調査', '林さんが市場調査、吉田さんが予算管理', 'リーダーが市場調査、林さんがスケジュール管理', '吉田さんがスケジュール管理、リーダーが予算管理'],
    answer: 1,
    explanation:
      '冒頭で「市場調査は林さん、予算管理は吉田さん」と明確に述べられており選択肢2が正解。対話後半で林さんが市場調査の締め切りを、吉田さんが予算書フォーマットをそれぞれ確認していることも担当の裏付けになる。この種の多人物役割分担問題は「〜は〜さん」の構文を聞いた瞬間に紙に対応を書き留める習慣が有効。',
  },
  {
    id: 26,
    number: '26番',
    type: 'comprehensive_listening',
    difficulty: 'J1+',
    section: 'listening_section3',
    knowledgePoint: '条件分岐の聴解：「〜は〜、それ以外は〜」の2分岐構造',
    scene: '上司が部下にセミナー参加者へのフォローアップ方法を指示している',
    lines: [
      '上司：先週のセミナー参加者にお礼メールを送ってください。',
      '名刺をもらったお客様には個別に送ること。それ以外の方には一斉送信で構いません。',
      '件名は「先日はご参加いただきありがとうございました」という趣旨で。',
      '文面は任せます。今日中にお願いします。',
    ],
    options: ['全員に個別メールを送る', '全員に一斉送信メールを送る', '名刺入手者には個別、それ以外は一斉送信', '名刺入手者には送らず、それ以外のみに送る'],
    answer: 2,
    explanation:
      '上司の指示は条件分岐構造：「名刺をもらったお客様には個別」「それ以外は一斉送信」。選択肢3が両条件を正確に反映している。「それ以外は〜」は分岐の信号語で、前条件と対照して記憶することが必要。選択肢1・2はそれぞれ一方の条件のみを示した不完全な回答。',
  },
  {
    id: 27,
    number: '27番',
    type: 'comprehensive_listening',
    difficulty: 'J1',
    section: 'listening_section3',
    knowledgePoint: '因果関係の聴解：原因と結果の正確な対応付け',
    scene: 'マーケティング部の会議でアパレル部門の売上不振原因を分析している',
    lines: [
      'マネージャー：アパレル部門が前年比78%と落ち込んでいます。原因として3点考えられます。',
      'まず今年の季節外れの気候、次に競合他社の大型セール、そして当社の在庫不足です。',
      '来月の対策として、在庫を増やしてセールを実施します。',
    ],
    options: ['アパレルは前年比120%で好調だった', '原因はデザインの問題と価格の高さ', '季節・競合セール・在庫不足の3点が原因', '対策として広告費を増やすことにした'],
    answer: 2,
    explanation:
      '経理担当が3つの原因を列挙：季節外れの気候・競合他社のセール・自社の在庫不足。選択肢3が正確に反映。選択肢1は「120%で好調」としており78%の不振と正反対。選択肢2の「デザイン」「価格」は原文に登場しない架空の原因。選択肢4の対策は「在庫増加とセール実施」であり広告費は言及されていない。',
  },
  {
    id: 28,
    number: '28番',
    type: 'comprehensive_listening',
    difficulty: 'J2',
    section: 'listening_section3',
    knowledgePoint: '複数時間情報の聴解：異なる事項の期限を混同しない',
    scene: '課長が朝礼で複数の連絡事項を伝えている',
    lines: [
      '課長：3点お知らせします。来週月曜から午前中はシステムメンテナンスでメールが使えません。午後1時から通常通りです。',
      '次に、来月の全社会議ですが、場所が本社から東館大ホールに変更になりました。',
      '参加登録の締め切りは今週金曜日です。必ず登録してください。',
    ],
    options: ['メール停止は午前中のみ、登録締め切りは来月', 'メール停止は一日中、登録締め切りは今週金曜', 'メール停止は午前中のみ、登録締め切りは今週金曜', 'メール停止はなし、会議の場所は変更なし'],
    answer: 2,
    explanation:
      '2つの情報を同時に正確に把握する必要がある：メール停止は「午前中のみ・午後1時から通常通り」、登録締め切りは「今週金曜日」。選択肢3が両者を正確に示している。選択肢1は登録期限を「来月」とし誤り。選択肢2はメール停止を「一日中」とし誤り。複数事項の時間表現は事項ごとに対応させて記録することが重要。',
  },
  {
    id: 29,
    number: '29番',
    type: 'comprehensive_listening',
    difficulty: 'J1+',
    section: 'listening_section3',
    knowledgePoint: '専門家の主張聴解：「最も〜は〜」という強調表現で主論点を特定',
    scene: 'ラジオで働き方改革についてコンサルタントがインタビューに答えている',
    lines: [
      'コンサルタント：長時間労働から成果主義への転換が進んでいます。',
      '最も大きな課題は管理職の意識改革です。部下に早退を勧めながら自分は残る矛盾が多くの職場にあります。',
      '成果の測定方法も時間ではなくアウトプットで評価する仕組みが必要です。',
      'まず会議の効率化から始めることをお勧めします。',
    ],
    options: ['長時間労働の即時禁止が最優先課題', '管理職の意識改革が最も大きな課題', '新しい賃金制度の導入が急務', '在宅勤務の全面導入が解決策'],
    answer: 1,
    explanation:
      '「最も大きな課題は管理職の意識改革です」という文が話者の主張を直接明示している。「最も〜は〜」は聴解において主要論点を識別する重要な信号表現。「会議の効率化」はコンサルタントが最初の一歩として勧めたものであり、最大課題ではない。「賃金制度」「在宅勤務」は言及されていない。',
  },
  {
    id: 30,
    number: '30番',
    type: 'comprehensive_listening',
    difficulty: 'J2',
    section: 'listening_section3',
    knowledgePoint: 'プレゼン研修の聴解：PREP法と1スライド1メッセージの原則',
    scene: '社内研修でプレゼンテーションの原則について講師が説明している',
    lines: [
      '講師：プレゼンを成功させるには準備が9割です。',
      'まず聞き手が誰かを明確にしてください。経営層向けと現場向けでは強調すべき内容が全く異なります。',
      '構成はPREP法が効果的です。結論を最初に述べ、根拠を3点程度に絞ります。',
      'スライドは1枚1メッセージを原則に。練習は声に出して行うことを強くお勧めします。',
    ],
    options: ['スライドに情報を詰め込み視覚的に豊かにする', '結論は最後に述べて聞き手の興味を引き付ける', 'PREP法で結論を最初に述べ根拠を絞って説明する', '練習は頭の中で繰り返すことが効果的'],
    answer: 2,
    explanation:
      'PREP法については「結論を最初に述べ、根拠を3点程度に絞る」と明確に説明しており選択肢3が正解。選択肢1は「1スライド1メッセージ」の原則と正反対。選択肢2は結論の位置（最初vs最後）が逆。選択肢4については「頭の中だけでは不十分」とし「声に出す」ことを推奨している。選択肢が原文の「逆」になっている誤答誘導パターンに注意。',
  },
  {
    id: 31,
    number: '31番',
    type: 'comprehensive_listening',
    difficulty: 'J1+',
    section: 'listening_section3',
    knowledgePoint: '会議での評価聴解：話者ごとの提案とその問題点を正確に対応させる',
    scene: '新製品の企画会議で田中・鈴木両名が提案をし、部長が評価している',
    lines: [
      '企画部長：では各自の提案を聞かせてください。',
      '田中：若い世代向けのスマートフォン連携製品を提案します。SNSとの親和性が高く拡散も期待できます。',
      '鈴木：シニア層向けのシンプル設計製品を提案します。高齢化社会で市場が拡大する一方です。',
      '企画部長：田中案はトレンドを押さえていますが競合が多い。鈴木案は差別化しやすいが販売チャネルが課題ですね。',
    ],
    options: ['田中案の問題点は市場規模が小さいこと', '鈴木案の問題点は競合が多いこと', '部長は田中案に競合の多さを問題として指摘した', '部長は両案とも採用しないと決めた'],
    answer: 2,
    explanation:
      '部長の評価：田中案「トレンドを押さえているが競合が多い」、鈴木案「差別化しやすいが販売チャネルが課題」。選択肢3が田中案に対する問題点指摘を正確に反映。選択肢1は「市場規模が小さい」という言及はなく、これは鈴木案の強みとして述べられている高齢化市場と逆。選択肢2は田中案の問題（競合）を鈴木案に誤帰属。選択肢4は「引き続き両案を検討」とあり採用不採用の判断は下していない。',
  },
  {
    id: 32,
    number: '32番',
    type: 'comprehensive_listening',
    difficulty: 'J2',
    section: 'listening_section3',
    knowledgePoint: 'クレーム対応手順の聴解：4段階プロセスの順序把握',
    scene: '先輩社員がクレーム対応の手順を後輩に教えている',
    lines: [
      '先輩：クレームが入ったらまず謝罪の電話をしてください。',
      'その後、原因を調査して状況を報告します。',
      '解決策が決まったら再度ご連絡して、最終的に書面でお詫びを送ります。',
      '後輩：メールではだめですか。',
      '先輩：初動は必ず電話です。メールだけでは誠意が伝わりにくいですから。',
    ],
    options: ['メール謝罪→原因調査→電話報告', '電話謝罪→原因調査→解決策連絡→書面謝罪', '書面謝罪→電話謝罪→原因調査', '原因調査→電話謝罪→書面謝罪'],
    answer: 1,
    explanation:
      '先輩が示した4つの手順：電話謝罪→原因調査・状況報告→解決策決定後に再連絡→書面謝罪。選択肢2が完全に正しい順序。先輩は「初動は必ず電話」と明言しているため選択肢1のメール謝罪から始まる順序は誤り。書面謝罪が最後に来ることも重要なポイント。「まず・その後・最終的に」などの時系列標識語に注目することが順序聴解の鍵。',
  },
  {
    id: 33,
    number: '33番',
    type: 'comprehensive_listening',
    difficulty: 'J1',
    section: 'listening_section3',
    knowledgePoint: '文書分類の聴解：社内文書と社外文書の区別',
    scene: '新人研修でビジネス文書の種類と特徴を説明している',
    lines: [
      '講師：ビジネス文書は大きく社内文書と社外文書に分けられます。',
      '社内文書は報告書・議事録・稟議書など社内で使うものです。',
      '社外文書は見積書・注文書・請求書など取引先とやり取りするものです。',
      '文書作成で最も重要なのは5W1Hを明確にすること、そして簡潔に書くことです。',
    ],
    options: ['稟議書は社外文書である', '見積書・請求書は社外文書である', '議事録は社外文書である', '報告書は取引先に提出するものである'],
    answer: 1,
    explanation:
      '原文：「見積書・注文書・請求書」は社外文書と明確に分類されており選択肢2が正解。「稟議書」は社内文書として列挙されており選択肢1は誤り。「議事録」も社内文書のため選択肢3は誤り。「報告書」は社内文書で対外提出は行わないため選択肢4は誤り。分類聴解では各具体例を聴いた瞬間に社内か社外かを即座に分類する練習が有効。',
  },
  {
    id: 34,
    number: '34番',
    type: 'comprehensive_listening',
    difficulty: 'J1+',
    section: 'listening_section3',
    knowledgePoint: '含意推測：「検討します」のビジネス的含意を正確に把握',
    scene: '先輩が後輩にビジネス慣用表現の実際の意味を教えている',
    lines: [
      '後輩：今日の会議で部長が「検討します」と言ったんですが、採用される可能性ありますよね？',
      '先輩：正直に言うと、ビジネスの場では「検討します」はたいていお断りの意味だよ。',
      '後輩：えっ、そうなんですか！',
      '先輩：「善処します」も「前向きに検討します」も似たようなものだね。こういう言い回しに慣れておかないと。',
    ],
    options: ['「検討します」は必ず採用されるという意味', '「検討します」はビジネスではたいてい断りの意味', '「善処します」は「検討します」より前向きな返答', '「前向きに検討します」は必ず採用を意味する'],
    answer: 1,
    explanation:
      '先輩は「ビジネスの場では「検討します」はたいていお断りの意味」と明言している。選択肢2が正解。「たいてい」は「通常・大体」の意味で方向性は断りと明確。「善処します」と「前向きに検討します」も先輩は同類の曖昧表現として同列に位置づけており、選択肢3「より前向き」は誤り。選択肢4も同様に誤り。',
  },
  {
    id: 35,
    number: '35番',
    type: 'comprehensive_listening',
    difficulty: 'J2',
    section: 'listening_section3',
    knowledgePoint: '会議での指示聴解：上司の最終指示と各自の担当を正確に把握',
    scene: '営業戦略会議で部門の課題と解決策を議論し、部長が指示を出している',
    lines: [
      '部長：今月の売上不振の原因を分析してください。',
      '田中：主な原因は新規顧客へのアプローチ不足だと思います。既存顧客への依存度が高すぎます。',
      '鈴木：私はアフターフォロー不足だと思います。契約後の連絡が少なく、リピート率が下がっています。',
      '部長：両方あり得ますね。田中さんは来月から新規開拓に集中、鈴木さんはアフターフォローの仕組みを作ってください。',
    ],
    options: ['田中がアフターフォロー強化、鈴木が新規開拓を担当', '田中が新規開拓、鈴木がアフターフォロー仕組み作りを担当', '両人とも新規開拓を担当することになった', '部長が直接新規開拓を行うことになった'],
    answer: 1,
    explanation:
      '部長の最終指示：「田中さんは新規開拓に集中、鈴木さんはアフターフォローの仕組みを作る」。選択肢2が正確に対応。選択肢1は田中と鈴木の担当を完全に入れ替えており典型的な混淆陷阱。会議場面では冒頭の原因分析発言より、末尾の上司・部長による指示が正解の根拠になることが多い。指示の瞬間に集中して聴くことが鍵。',
  },
  {
    id: 36,
    number: '36番',
    type: 'comprehensive_listening',
    difficulty: 'J1+',
    section: 'listening_section3',
    knowledgePoint: 'インタビュー聴解：CEOの見解・会社の取り組み・デメリット評価を区別',
    scene: 'テレビニュースでIT企業CEOがテレワークについてインタビューに答えている',
    lines: [
      'CEO：テレワークは今後もハイブリッド型が主流になると思います。',
      'デメリットはコミュニケーションの質低下と、新入社員育成の難しさです。',
      'ただし適切なツールとマネジメントでかなり解決できます。',
      '弊社では週1回全員が集まる日を設け、残りは個人の裁量に任せています。',
    ],
    options: ['CEOの会社は毎日全員が出社する', 'テレワークのメリットのみを強調した', 'CEOは週1回の全員出社とその他は裁量制を実施している', '新入社員育成の問題は解決不可能だと述べた'],
    answer: 2,
    explanation:
      '「週1回全員が集まる日を設け、残りは個人の裁量に任せている」という具体的な制度説明が根拠で選択肢3が正解。選択肢1は「毎日」と述べているが原文は「週1回」のみ。選択肢2はCEOがデメリットも明言しているため誤り。選択肢4はCEOが「適切なツールとマネジメントでかなり解決できる」と述べており解決可能としており誤り。',
  },
  {
    id: 37,
    number: '37番',
    type: 'comprehensive_listening',
    difficulty: 'J2',
    section: 'listening_section3',
    knowledgePoint: '交渉場面の聴解：提案・反応・合意状況を段階的に把握',
    scene: '購買担当者とサプライヤーが価格交渉を行っている',
    lines: [
      '購買担当：今回の発注量を増やす代わりに、単価を5%下げていただくことはできますか。',
      'サプライヤー：今すぐ5%は難しいですが、来季の契約更新時であれば3%の値引きは可能です。',
      '購買担当：3%では少し足りないですね。4%はいかがでしょうか。',
      'サプライヤー：4%は…上司に確認が必要ですが、前向きに検討いたします。',
    ],
    options: ['今回の発注から5%値引きで合意した', '来季から3%値引きで合意した', '4%値引きについてサプライヤーが上司確認を約束した', '交渉は決裂して取引中止となった'],
    answer: 2,
    explanation:
      'サプライヤーは4%について「上司に確認が必要だが前向きに検討する」と述べており、現在の交渉状態を示す選択肢3が正解。5%は「今すぐ難しい」と断られ、3%は購買側が不満を示し、4%は検討中という段階的な交渉の流れを正確に把握することが必要。「合意した」と断言している選択肢1・2は未確定の状況を過度に確定的に表現しており誤り。',
  },
  {
    id: 38,
    number: '38番',
    type: 'comprehensive_listening',
    difficulty: 'J1',
    section: 'listening_section3',
    knowledgePoint: '出張手配の聴解：往路・復路・ホテルの予約状況を個別に把握',
    scene: '上司と部下が大阪出張の手配状況について話し合っている',
    lines: [
      '上司：大阪出張の新幹線、予約は取れましたか。',
      '部下：往路は月曜朝8時発ののぞみを取りました。復路はまだです。',
      '上司：帰りは会議の終わり次第だから、18時・19時・20時発の3本を候補で調べておいて。',
      '部下：承知しました。ホテルも同時に押さえておきましょうか。',
      '上司：ホテルは経費の関係で今回は日帰りにしてください。',
    ],
    options: ['往路・復路ともに予約済み', '往路のみ予約済みで復路は3本候補を調べる', '復路のみ予約済みで往路はこれから手配', 'ホテルをまず予約してから新幹線を手配する'],
    answer: 1,
    explanation:
      '「往路は取った・復路はまだ」から現在の予約状況が明確。さらに上司が「18・19・20時発の3本を調べるよう」指示したことで、今後の作業が復路候補の調査であることがわかる。選択肢2がこの状況と指示を正確に反映。ホテルは「日帰り」で不要と決定済みであり選択肢4は誤り。',
  },
  {
    id: 39,
    number: '39番',
    type: 'comprehensive_listening',
    difficulty: 'J1+',
    section: 'listening_section3',
    knowledgePoint: '人事異動の聴解：抜擢の理由と補完措置を正確に把握',
    scene: '部長と課長が部下の海外営業異動について話し合っている',
    lines: [
      '部長：来月から山田さんに海外営業を担当させようと思っています。',
      '課長：英語力は問題ないですが、海外取引の経験が浅いのが少し心配です。',
      '部長：だから最初の3ヶ月は中村さんとペアで動いてもらおうと思って。',
      '課長：それなら安心です。山田さんも早く成長できると思います。',
    ],
    options: ['山田さんは英語力が不足しているため中村さんと組む', '山田さんの海外取引経験不足を補うため中村さんとペアにする', '中村さんの英語力強化のため山田さんと組ませる', '山田さんを即戦力として単独で海外営業に配属する'],
    answer: 1,
    explanation:
      '「英語力は問題ない」と明言されているため選択肢1の英語力不足は誤り。「海外取引の経験が浅い」という課題に対し「だから中村さんとペアで」という因果接続がある。「だから」は理由を示す接続詞で経験不足→ペア配置の因果関係を明示。選択肢2がこの因果関係を正確に反映。選択肢4は「単独配属」としており補完措置を無視している。',
  },
  {
    id: 40,
    number: '40番',
    type: 'comprehensive_listening',
    difficulty: 'J2',
    section: 'listening_section3',
    knowledgePoint: '決算スピーチの聴解：現状の課題認識と来期の3本柱戦略の把握',
    scene: '決算報告会で社長がステークホルダーに向けてスピーチをしている',
    lines: [
      '社長：今期は売上5%増と目標を達成できましたが、利益率の低下は課題として残っています。',
      '来期は原材料調達の多様化、高付加価値製品へのシフト、デジタル化による効率化の3本柱で臨みます。',
      '厳しい事業環境が続きますが、皆様のご支援を賜りながら、持続的な成長を実現してまいります。',
    ],
    options: ['社長は今期の結果に完全に満足している', '来期は利益率改善を中心に3つの戦略を掲げている', 'デジタル化より人材採用を優先する方針', '売上目標は未達だったが利益率は改善された'],
    answer: 1,
    explanation:
      '社長は「利益率の低下は課題として残っている」と述べ、来期3本柱（調達多様化・高付加価値化・デジタル効率化）でその改善を図る方針を示している。選択肢2がこの全体像を正確に概括。選択肢1は「完全に満足」としているが課題を明言しており誤り。選択肢3の「人材採用」は一切言及されていない無中生有の誤答。選択肢4は売上と利益率の結果を入れ替えており事実と逆。',
  },
];
